window.elevate.onTrackingConsentGranted(() => {
  document.body.addEventListener('click', async e => {
    const div = e.target.closest('div[data-ticket]');
    if (!div) return;

    if (div.dataset.locked === 'true') return;
    div.dataset.locked = 'true';

    try {
      const isAddToCartClick = e.target.closest('.prd-Card_Buttons') || e.target.getAttribute('data-ticket') !== null;

      if (isAddToCartClick) {
        console.log("[ELEVATE] Adding to cart: ", div.dataset.ticket)
        await window.elevate.api.notify.addToCart(div.dataset.ticket);
      } else {
        console.log("[ELEVATE] Clicking: ", div.dataset.ticket)
        await window.elevate.api.notify.click(div.dataset.ticket);
      }

    } catch (err) {
      console.error('[ELEVATE] API error:', err);
    } finally {
      div.dataset.locked = 'false';
    }
  });
})




